<template>

    <b-modal v-if="formData"
             v-model="modalEditClient"
             ref="my-modal"
             id="modal-client"
             no-close-on-backdrop
             centered
             hide-footer
             :title="`${$t('labels.editClient')}: ${formData.name}`">

        <b-form @submit.prevent="updateForm">

            <b-form-checkbox
                    v-model="formData.status"
                    name="check-button"
                    switch
                    inline>
                <div>
                  {{ $t("labels.clientStatus") }} <b>{{ formData.status ? $t("labels.activeStatus") : $t("labels.inactiveStatus") }}</b>
                </div>
            </b-form-checkbox>
            <hr>

            <b-form-group :label="$t('labels.description')">
                <b-form-input
                        v-model="formData.description"
                        type="text"
                        :placeholder="$t('labels.description')"
                />
            </b-form-group>

            <b-form-group :label="$t('labels.tax')">
                <b-form-input
                        v-model="formData.tax"
                        type="number"
                        :placeholder="$t('labels.tax')"
                />
            </b-form-group>

            <b-form-group :label="$t('labels.currencies')">
                <v-select
                        v-model="formData.activeCurrencies"
                        label="name"
                        multiple=""
                        :reduce="currency => currency._id"
                        :close-on-select="false"
                        :options="currencies"
                />
            </b-form-group>

            <b-form-group :label="$t('labels.defaultCurrency')">
                <v-select
                        v-model="formData.defaultCurrency"
                        label="name"
                        :reduce="currency => currency._id"
                        :options="currenciesToSelectLikeDefault"
                />
            </b-form-group>

            <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1">
              {{$t('buttons.submit')}}
            </b-button>

        </b-form>
    </b-modal>
</template>

<script>
  import { mapActions } from 'vuex'
  import { VueGoodTable } from 'vue-good-table'
  import {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BOverlay,
    BPagination,
    VBModal,
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import addUpdateClient from './addUpdateClient'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import Ripple from 'vue-ripple-directive'

  export default {
    name: 'EditClient',
    components: {
      VueGoodTable,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      VBModal,
      BForm,
      BButton,
      vSelect,
      BFormCheckbox,
      BCard,
      addUpdateClient,
      BOverlay,
      ToastificationContent
    },

    directives: {
      'b-modal': VBModal,
      Ripple,
    },

    data(){
      return{
        formData : {
          tax : '',
          _id : '',
          status : '',
          description : '',
          activeCurrencies : '',
          defaultCurrency  : '' ,
        },
        currenciesToSelectLikeDefault :[],
        currencies : [],
        modalEditClient : false,
      }
    },

    methods:{
      ...mapActions('client', ['users', 'destroy', 'update']),
      ...mapActions('role', ['roles']),
      ...mapActions("wallet", ["show"]),

      async updateForm(){
        try {
          let response = await this.update(this.formData)
            this.refreshCientList()
            this.$swal({
              title: this.$t('labels.updatedClient'),
              text: response.message,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
        } catch (error) {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('labels.error'),
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: `${error.response.data.message}`,
            },
          });
        }
      },

      async showModal(formData){
          console.log(formData)
        this.formData.description = formData.description
        this.formData._id = formData._id
        this.formData.tax = formData.tax
        this.formData.status = formData.status
        this.formData.name = formData.name
        const clientCurrencies  = formData.currencies
        if (clientCurrencies){
          const activesCurrencies = clientCurrencies.filter(currencies => currencies.active).map(currency => {
            return Object.assign({}, currency.currency)
          })
          this.currencies = clientCurrencies.map(currency => {
            return Object.assign({}, currency.currency)
          })
          console.info(this.currencies)
          this.currenciesToSelectLikeDefault = activesCurrencies
          this.formData.activeCurrencies = activesCurrencies.map(item => item._id);
          this.formData.defaultCurrency = formData.defaultCurrency._id
        }

        this.modalEditClient = true
      },

      hideModal(){
        this.formData = {
          tax : '',
          _id : '',
          status : '',
          description : '',
          activeCurrencies : '',
          defaultCurrency  : '' ,
        }
        this.currenciesToSelectLikeDefault = []
        this.currencies = []
        this.modalEditClient = false
      },

      refreshCientList(){
        this.hideModal()
        this.$emit('refreshCientList')
      }

    },

    created() {
    }

  }
</script>

<style scoped>

</style>